export default __webpack_public_path__ + "static/media/sketched-arrow.a38ee5ce.png";